import { all, takeEvery, call, put } from "redux-saga/effects";
import * as actionTypes from "../constants/actionTypes";
import * as actions from '../actions'
import axios from '../services';
import { sessionExpiredMsg } from "../constants/constants";

function* getSingleMediaData(action) {
    try {
        let response = yield axios.get(`/users/get-media?userId=${action.payload.userId}&mediaId=${action.payload.mediaId}&contestName=${action.payload.contestName}`)
            .then(async response => response)
            .catch(async error => {
                return error;
            });

        if (response == "Error: Request failed with status code 401") {
            yield put(actions.hideAppLoader());
            put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        } else if (response.status !== 200) {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: response.response.data.msg }));
        } else {
            yield put(actions.getSingleMediaDataSuccess({
                singleMediaFeed: response.data.data
            }));
        }
    } catch (error) {
        //  console.log("ERROR FROM SAGA FEATURED VIDEO", error.message);
        if (error == "Error: Request failed with status code 401") {
            yield put(actions.modalOpen({ message: sessionExpiredMsg, redirectURL: `/logout` }));
        }
        if (error == "Error: Request failed with status code 500") {
            yield put(actions.hideAppLoader());
            yield put(actions.modalOpen({ message: error.response.data.msg }));
        }
    }
}


export default function* rootsaga() {
    yield takeEvery(actionTypes.GET_SINGLE_MEDIA_DATA, getSingleMediaData);
}